import React, { useContext, type PropsWithChildren } from 'react';

const HideDescendentNodesContext = React.createContext<boolean>(false);

export const useIsAncestrallyHidden = () =>
  useContext(HideDescendentNodesContext);

export const SubtreeNodeVisibilityWrapper = ({
  isHidden,
  children,
}: PropsWithChildren<{ isHidden: boolean }>) => {
  const resolvedIsHidden = useIsAncestrallyHidden() || isHidden;
  return (
    <HideDescendentNodesContext.Provider value={resolvedIsHidden}>
      {children}
    </HideDescendentNodesContext.Provider>
  );
};
